<template>
  <div class="pn-platforms">
    <div class="head">
      <b-form-checkbox v-model="isChecked" switch size="lg">
        Send to <b>Huawei</b>
      </b-form-checkbox>
    </div>
    <div class="content" v-if="isChecked">
      <!-- <base-input label="Image" v-model="values.bigImage" placeholder="" /> -->
      <base-input label="Sound" v-model="values.sound" placeholder=".wav .aiff .caf" />
      <div class="form-group">
        <p class="fs-14 bold mb-2">Delivery Type</p>
        <b-form-checkbox label="Sound" v-model="values.silent">Silent</b-form-checkbox>
      </div>
      <base-input label="Large Icon URL" v-model="values.largeIcon" placeholder="" />
      <base-input label="Small Icon URL" v-model="values.smallIcon" placeholder="" />
      <base-input label="Led Color" v-model="values.ledColor" placeholder="" />
      <base-input label="Accent Color" v-model="values.accentColor" placeholder="" />
    </div>
  </div>
</template>

<script>
import { Select, Option } from 'element-ui';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: ['payload', 'checked'],
  created() {
    if (this.checked) {
      this.$emit('update', {
        option: this.option,
        values: this.values,
      });
    }
  },
  data: () => ({
    isInit: true,
    option: 'hmsApp',
    isChecked: false,
    values: {
      bigImage: '',
      sound: '',
      silent: false,
      largeIcon: '',
      smallIcon: '',
      ledColor: '',
      accentColor: '',
    }
  }),
  watch: {
    payload: {
      deep: true,
      handler(val) {
        if (this.isInit) {
          this.checked = !!val[this.option];

          Object.keys(this.values).forEach((key) => {
            if (val[this.option]) this.$set(this.values, key, val[this.option][key]);
          });

          this.isInit = false;
        }
      },
    },
    checked: {
      immediate: true,
      handler(val) {
        this.isChecked = val;
      },
    },
    isChecked(val) {
      this.$emit('update', {
        option: this.option,
        values: val ? this.values : null,
      });
    },
    values: {
      deep: true,
      handler(val) {
        this.$emit('update', {
          option: this.option,
          values: val,
        });
      },
    },
  },
};
</script>
